import React, { Component } from 'react';
import { Session, OrderDetailsModal, Footer, NavBar } from "../../components";
import { DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient/ApiClient";
import { connect } from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

require('datatables.net-bs4');

const apiClient = ApiClient.getInstance();

class OrdersView extends Component {

    // Se agrego el contructor y la tabla para limpirar
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            order: {
                header: {},
                body: []
            },
        };
        this.table = null;
    }

    async componentDidMount() {
        // const { enableSpinner } = this.props;
        // enableSpinner(true);
        // let response = await apiClient.getOrders();
        // enableSpinner(false);
        // if (response.status === SERVICE_RESPONSE.SUCCESS) {
        //     this.setState({
        //         orders: response.data,
        //     });
        //     $('#tablaOrder').DataTable({
        //         "paging": false,
        //         "info": false,
        //         "searching": false
        //     });
        // }
        this.fillDataOrders();
    }
    // Se llena la tabla con la configuración
    fillDataOrders = () => {
        this.table =  $('#tablaOrder').DataTable({
            "paging": true,
            "info": false,
            "searching": false,
            //"bDestroy": true,	
            "order": [[ 0, 'desc' ]],
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "No se encontraron registros",
                "info": "Mostrando página _PAGE_ de _PAGES_",
                "infoEmpty": "No existen registros",
                "infoFiltered": "(filtrado de _MAX_ entradas)",
                "loadingRecords": "Buscando...",
                "processing": "Procesando...",
                "search": "Buscar:",
                "paginate": {
                    "first": "Primero",
                    "last": "Último",
                    "next": "Siguiente",
                    "previous": "Anterior"
                }
            }
        });
    }
    // Se vacia la tabla
    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        if (this.props.orders != nextProps.orders) {
            //console.log("hay nuevos datos");
            this.table.destroy();
            this.table = null;
        }
        return true;
    }
    // se llena la tabla
    componentDidUpdate(): void {
        if (this.table == null) {
            this.fillDataOrders();
        }
    }

    openOrder = async docEntry => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let response = await apiClient.getOrder(docEntry);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
            });

            $('#orderDetailsModal').modal('show');
            return;
        }

        showAlert({ type: 'error', message: response.message })
    };
    docChangeName(status) {
        let result = '';
        switch (status) {
            case 'O':
                result = "Abierto";
                break;
            case 'C':
                result = "Cerrado";
                break;
            default:
                break;
        }
        return result;
    };
    docChangeNameFMB(status) {
        let result = '';
        switch (status) {
            case '0':
                result = "Sin Atención";
                break;
            case '1':
                result = "Atendido";
                break;
            case '2':
                result = "Facturado";
                break;
            default:
                break;
        }
        return result;
    };

    render() {
        const { order } = this.state;
        const { orders, getData,handleInputDateInicio, handleInputDateFinal, fechaFinal,fechaInicio}  = this.props;
        return (
            <div className="content-fluid" >
                <OrderDetailsModal order={order} />
                <div className="row text-center" style={{ marginBottom: 16, marginTop: 16 }}>
                    <div className="col-md-12">
                        <h3>Pedidos</h3>
                    </div>
                </div>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className=" row col-md-4">
                        <h4 className="pr-2">Desde:</h4>
                        <input 
                            id="fechaInicio"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechauno" 
                            value = {fechaInicio}
                            onChange = {(event) => handleInputDateInicio(event)}/>
                    </div>
                    <div className="row col-md-4 pb-3">
                        <h4 className="pr-2">Hasta:</h4>
                        <input 
                            id="FechaFin"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechados" 
                            value = {fechaFinal}
                            onChange = {(event) => handleInputDateFinal(event)}/>
                    </div>
                    <div className="col-md-2 pb-2">
                        <button
                            onClick={()=>getData(1)}
                            className="btn botonResumen" 
                            style={{
                                backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                color: config.navBar.textColorCategorieHover,
                                fontWeight: "bold",
                            }}>
                            Ver pedidos
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 table-responsive">
                        <table id="tablaOrder" class="table table-striped">
                            <thead>
                                <tr style={{ backgroundColor: config.shoppingList.summaryList, color: "white" }}>
                                    <th scope="col">No. de pedido</th>
                                    <th scope="col">Fecha de creación</th>
                                    <th scope="col">Dirección de entrega</th>
                                    <th scope="col">Estado del documento</th>
                                    <th scope="col">Estado del pedido</th>
                                    <th scope="col">Total peso neto</th>
                                    <th scope="col">Total peso bruto</th>
                                    <th scope="col">Cant. de articulos</th>
                                    <th scope="col">Cant. de unidades</th>
                                    <th scope="col">Valor total</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => {
                                    return (<tr key={index}>
                                        <th scope="row">{order.DocNum}</th>
                                        <td>{moment(order.TaxDate).format('DD-MM-YYYY')}</td>
                                        <td>{order.Address2}</td>
                                        <td>{this.docChangeName(order.DocStatus)}</td>
                                        <td>{this.docChangeNameFMB(order.U_FMB_Handel_Status)}</td>
                                        <td>{order.Weight1 === null ? '0 KG' : parseFloat(order.Weight1).toFixed(2)+ ' KG'}</td>
                                        <td>{order.Weight2 === null ? '0 KG' : parseFloat(order.Weight2).toFixed(2)+ ' KG'}</td>
                                        <td>{parseInt(order.Cant)}</td>
                                        <td>{parseInt(order.Unit)}</td>
                                        <td className="text-right">
                                            {/* <CurrencyFormat
                                                value={order.DocTotal}
                                                displayType={'text'}
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat> */}
                                            <CurrencyFormat 
                                                value={order.DocTotal} 
                                                displayType={'text'} 
                                                thousandSeparator={true} 
                                                fixedDecimalScale={true} 
                                                decimalScale={2} 
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td>
                                        <td>
                                            <span onClick={() => this.openOrder(order.DocEntry)}>
                                                <i className={config.icons.detail} style={{ color: config.shoppingList.summaryList, paddingRight: 6 }}></i>
                                                Detalle
                                            </span>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrdersView);